import styled from 'styled-components';

export const Container = styled.div`
    position: absolute;
    bottom: 0px;
    right: 0px;
`
